__webpack_require__.p = "/product-updates-beamer-integration-feedback-v1/referrals-hub/";